<template>
  <v-row justify="center" class="mt-8">
    <v-col cols="12" sm="8" md="5">
      <v-card flat class="pa-6 gps-connect-card">
        <div class="text-center mb-4">
          <v-icon size="40" color="primary">mdi-truck-fast-outline</v-icon>
          <h2 class="text-h6 mt-2">{{ $t("finance_gps_connect_title") }}</h2>
          <p class="grey--text text--darken-1">
            {{ $t("finance_gps_connect_description") }}
          </p>
        </div>

        <v-form @submit.prevent="login">
          <v-text-field
            v-model="username"
            :label="$t('finance_email_label')"
            type="email"
            outlined
            dense
            :error-messages="errorMessage ? [''] : []"
          />
          <v-text-field v-model="password" :label="$t('finance_password_label')" type="password" outlined dense />
          <v-alert v-if="errorMessage" type="error" dense text class="mb-4">
            {{ errorMessage }}
          </v-alert>
          <v-btn color="primary" block depressed :loading="loading" type="submit">
            {{ $t("finance_connect_button") }}
          </v-btn>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import gpsAuthService from "@/services/gps/gpsAuth";

export default {
  name: "GpsAccountConnect",

  data: () => ({
    username: "",
    password: "",
    loading: false,
    errorMessage: "",
  }),

  methods: {
    async login() {
      if (!this.username.trim() || !this.password.trim()) {
        this.errorMessage = this.$t("finance_enter_email_password");
        return;
      }

      this.loading = true;
      this.errorMessage = "";
      try {
        await gpsAuthService.login(this.username.trim(), this.password);
        this.$emit("connected");
      } catch (error) {
        this.errorMessage =
          error?.response?.data?.message || this.$t("finance_wrong_credentials");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.gps-connect-card {
  border-radius: 16px;
  border: 1px solid rgba(0, 0, 0, 0.08);
}
</style>
